import React, { useState, useEffect } from "react";
import { Form, Input, Select, Button, Upload } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import "../../css/common.css";
import useImageUpload from "../../../hooks/useImageUpload";
import { post } from "../../../services/services";
import { ApiURL, baseURL, S3_BASE_URL } from "../../../services/apiConstants";
import { ErrorToast, SuccessToast } from "../../../widgets/AppToast";
import { countries } from "../../../Data/data";

const { Option } = Select;

const CompanyProfile = () => {
  const [form] = Form.useForm();
  const [isEditing, setIsEditing] = useState(false);
  const [loader, set_loader] = useState(false);
  // const { fileList, setFileList, processFilesToBase64 } = useImageUpload([]);
  const [fileList, setFileList] = useState([]);

  const VIEW_AND_UPDATE_COMPANY_INFO = () => {
    try {
      const FORM_DATA = new FormData();
      post(ApiURL.view_update_company_info, FORM_DATA).then((res) => {
        if (res?.status === true) {
          const details = res?.company_data;

          // Set form fields
          form.setFieldsValue({
            name: res?.user_data?.name || "User Name",
            email: res?.user_data?.email || "",
            companyName: details?.company_name || "Company Name",
            companyEmail: details?.company_email || "",
            country: details?.country || "Select Country",
            city: details?.city || "City",
            state: details?.state || "State",
            zip: details?.zip_code || "ZIP/Postal Code",
            address: details?.address || "Address",
          });

          const photos = details?.photos || [];
          if (photos.length > 0) {
            const updatedFileList = photos.map((photo, index) => ({
              uid: `-${index}`,
              name: photo.split("/").pop(),
              status: "done",
              // url: `${S3_BASE_URL}${photo}`,
              // url: photo, 
              url: `${photo}?t=${Date.now()}`,
            }));
            setFileList(updatedFileList);
          } else {
            setFileList([]);
          }
        }
      });
    } catch (error) {
      console.log("show Error ***********", error);
    }
  };

  const onFinish = async (values) => {
    set_loader(true);
    // const base64Image = await processFilesToBase64();
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("name", values.name);
      FORM_DATA.append("email", values.email);
      FORM_DATA.append("company_name", values.companyName);
      FORM_DATA.append("company_email", values.companyEmail);
      FORM_DATA.append("country", values.country);
      FORM_DATA.append("city", values.city);
      FORM_DATA.append("state", values.state);
      FORM_DATA.append("zip_code", values.zip);
      FORM_DATA.append("address", values.address);
      // base64Image.forEach((image) => {
      //   FORM_DATA.append("photos", JSON.stringify(image));
      // });
        fileList.forEach((file) => {
      if (file.originFileObj) {
        FORM_DATA.append("photos", file.originFileObj);
      }
    });

      const res = await post(ApiURL.view_update_company_info, FORM_DATA);

      if (res?.status === true) {
        SuccessToast("Success Message", "Company info successfully updated!");
        setIsEditing(false);
        VIEW_AND_UPDATE_COMPANY_INFO();
      } else {
        ErrorToast("Error", "Submission failed. Please check required fields.");
      }
    } catch (error) {
      console.error("Submission error:", error);
      ErrorToast("Error", "An unexpected error occurred.");
    } finally {
      set_loader(false);
    }
  };

  useEffect(() => {
    VIEW_AND_UPDATE_COMPANY_INFO();
  }, []);

  // const handleChange = ({ fileList }) => {
  //   setFileList(fileList);
  //   if (fileList.length > 0 && fileList[0]?.originFileObj) {
  //     const reader = new FileReader();
  //     reader.readAsDataURL(fileList[0].originFileObj);
      
  //   }
  // };

  const handleChange = ({ fileList: newFileList }) => {
  setFileList(newFileList);
};

  const handlePreview = async (file) => {
    let src = file.url;
    if (!src && file.originFileObj) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const img = new Image();
    img.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(img.outerHTML);
  };

  return (
    <div className="white-container">
      <div style={{ padding: "20px", margin: "0 auto" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h2 style={{ fontWeight: "bold", marginBottom: "20px" }}>User Information</h2>

          {/* Logo Upload + Preview */}
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            {/* <Upload
              accept="image/*"
              listType="picture-card"
              fileList={fileList}
              onChange={handleChange}
              onPreview={handlePreview}
              beforeUpload={() => false}
              disabled={!isEditing}
              showUploadList={{
                showPreviewIcon: true,
                showRemoveIcon: isEditing,
              }}
            >
              {fileList.length >= 1
                ? null
                : isEditing && (
                    <div>
                      <PlusOutlined />
                      <div style={{ marginTop: 8 }}>Upload</div>
                    </div>
                  )}
            </Upload> */}
<Upload
  accept="image/*"
  listType="picture-card"
  fileList={fileList}
  onChange={handleChange}
  onPreview={handlePreview}
  beforeUpload={() => false}
  maxCount={1}
  disabled={!isEditing}
>
  {fileList.length >= 1 ? null : (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  )}
</Upload>
          
            <p style={{ margin: "5px 0 0 0", color: "#000" }}>www.example.com</p>
          </div>
        </div>

        <Form form={form} layout="vertical" onFinish={onFinish}>
          {/* User Name + Email */}
          <div style={{ display: "flex", gap: "20px", marginBottom: "20px" }}>
            {/* Name */}
            <div style={{ flex: 1 }}>
              <span style={{ fontWeight: "bold" }}>Name</span>
              <p style={{ margin: "5px 0 0 0" }}>
                {isEditing ? (
                  <Form.Item name="name" style={{ margin: 0 }}>
                    <Input />
                  </Form.Item>
                ) : (
                  form.getFieldValue("name") || "User Name"
                )}
              </p>
            </div>
            {/* Email */}
            <div style={{ flex: 1 }}>
              <span style={{ fontWeight: "bold" }}>Email</span>
              <p style={{ margin: "5px 0 0 0" }}>
                {isEditing ? (
                  <Form.Item name="email" style={{ margin: 0 }}>
                    <Input disabled />
                  </Form.Item>
                ) : (
                  form.getFieldValue("email") || "example@gmail.com"
                )}
              </p>
            </div>
          </div>

          {/* Company Info */}
          <h2 style={{ fontWeight: "bold", margin: "20px 0" }}>Company Information</h2>

          {/* Company Name + Country */}
          <div style={{ display: "flex", gap: "20px", marginBottom: "20px" }}>
            <div style={{ flex: 1 }}>
              <span style={{ fontWeight: "bold" }}>Company Name</span>
              <p style={{ margin: "5px 0 0 0" }}>
                {isEditing ? (
                  <Form.Item name="companyName" style={{ margin: 0 }}>
                    <Input />
                  </Form.Item>
                ) : (
                  form.getFieldValue("companyName") || "Company Name"
                )}
              </p>
            </div>
            <div style={{ flex: 1 }}>
              <span style={{ fontWeight: "bold" }}>Country</span>
              <p style={{ margin: "5px 0 0 0" }}>
                {isEditing ? (
                  <Form.Item name="country" style={{ margin: 0 }}>
                    <Select placeholder="Select Country">
                      {countries.map((country) => (
                        <Option key={country} value={country}>
                          {country}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                ) : (
                  form.getFieldValue("country") || "Select Country"
                )}
              </p>
            </div>
          </div>

          {/* Company Email + Zip */}
          <div style={{ display: "flex", gap: "20px", marginBottom: "20px" }}>
            <div style={{ flex: 1 }}>
              <span style={{ fontWeight: "bold" }}>Company Email</span>
              <p style={{ margin: "5px 0 0 0" }}>
                {isEditing ? (
                  <Form.Item name="companyEmail" style={{ margin: 0 }}>
                    <Input disabled />
                  </Form.Item>
                ) : (
                  form.getFieldValue("companyEmail") || "company@example.com"
                )}
              </p>
            </div>
            <div style={{ flex: 1 }}>
              <span style={{ fontWeight: "bold" }}>ZIP / Postal Code</span>
              <p style={{ margin: "5px 0 0 0" }}>
                {isEditing ? (
                  <Form.Item name="zip" style={{ margin: 0 }}>
                    <Input />
                  </Form.Item>
                ) : (
                  form.getFieldValue("zip") || "ZIP/Postal Code"
                )}
              </p>
            </div>
          </div>

          {/* City + State + Address */}
          <div style={{ display: "flex", gap: "20px", marginBottom: "20px" }}>
            <div style={{ flex: 1 }}>
              <span style={{ fontWeight: "bold" }}>City</span>
              <p style={{ margin: "5px 0 0 0" }}>
                {isEditing ? (
                  <Form.Item name="city" style={{ margin: 0 }}>
                    <Input />
                  </Form.Item>
                ) : (
                  form.getFieldValue("city") || "City"
                )}
              </p>
            </div>
            <div style={{ flex: 1 }}>
              <span style={{ fontWeight: "bold" }}>State</span>
              <p style={{ margin: "5px 0 0 0" }}>
                {isEditing ? (
                  <Form.Item name="state" style={{ margin: 0 }}>
                    <Input />
                  </Form.Item>
                ) : (
                  form.getFieldValue("state") || "State"
                )}
              </p>
            </div>
            <div style={{ flex: 1 }}>
              <span style={{ fontWeight: "bold" }}>Address</span>
              <p style={{ margin: "5px 0 0 0" }}>
                {isEditing ? (
                  <Form.Item name="address" style={{ margin: 0 }}>
                    <Input />
                  </Form.Item>
                ) : (
                  form.getFieldValue("address") || "Address"
                )}
              </p>
            </div>
          </div>

          {/* Edit/Save button */}
          <Form.Item style={{ textAlign: "right", marginBottom: "20px" }}>
            <Button
              loading={loader}
              type="primary"
              style={{ background: "#d32f2f", borderColor: "#d32f2f", borderRadius: "5px" }}
              onClick={() => (isEditing ? form.submit() : setIsEditing(true))}
            >
              {isEditing ? "Save" : "Edit"}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default CompanyProfile;
